import React from 'react';
import LanNopTien from './LanNopTien.jsx';
import { ShowIf } from 'components/utils';
import {Link} from 'react-router';

class ListLanNopTien extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state={
      data: this.props.data
    }
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.data != this.props.data) {
      this.setState({
        data: nextProps.data
      })
    }
  }

  addLanNopTien() {
    let newItem = {
      ngayNopTien: null,
      soTien: '',
      tongCong: '',
      conPhaiThu: ''
    }
    this.setState({
      data: [
        ...this.state.data,
        newItem
      ]
    }, () => {
      let data = {
        target: {
          value: this.state.data
        }
      }
      this.props.onChange(data)
    })
  }

  onChange(data,index) {
    this.state.data[index] = data
    this.setState({
      data: this.state.data
    }, () => {
      let data = {
        target: {
          value: this.state.data
        }
      }
      this.props.onChange(data)
    })
  }

  onRemove(index) {
    let newData = [...this.state.data];
    newData.splice(index, 1);
    this.state.data = newData;

    this.setState({
      data: this.state.data
    }, () => {
      let data = {
        target: {
          value: this.state.data
        }
      }
      this.props.onChange(data)
    })
  }

  render() {
    return (
      <div className='col-100'>
        {
          this.state.data.map((item, i) => {
            return(
              <LanNopTien key={i} {...item} view={this.props.view} onChange={this.onChange.bind(this)} onRemove={this.onRemove.bind(this)} index={i+1}/>
            )
          })
        }
        <ShowIf condition={this.props.view != true}>
          <div  className='mt5 mb15'><Link className='txt-green' onClick={this.addLanNopTien.bind(this)}> <i className='tt tt-addfile'/>Thêm ngày nộp tiền</Link></div>
        </ShowIf>
      </div>
    )
  }
}

ListLanNopTien.defaultProps = {
  data: []
}

export default ListLanNopTien;



// WEBPACK FOOTER //
// ./src/components/modules/theo-doi-thuc-hien/sub-view/ListLanNopTien.jsx